import axios from "axios"
export type LoginPayload = {
  loginId: string;
  password: string;
};

export type AuthUser = {
  id?: number;
  loginId?: string;
  name?: string;
  role?: string;
  [key: string]: any;
};

export type AuthResponse = {
  status: Number;
  data: {
    user: AuthUser | null;
  }
};

export const authApi = {
  async login(payload: LoginPayload) {
    const { data } = await axios.post<AuthResponse>("/api/auth/login", payload)
      .then(res => res.data);
    return data;
  },

  async refresh() {
    const { data } = await axios.post<AuthResponse>("/api/auth/refresh")
      .then(res => res.data);
    return data;
  },

  async logout() {
    const { data } = await axios.post("/api/auth/logout");
    return data;
  },

  async me() {
    const { data } = await axios.get<AuthResponse>("/api/dshop/auth/me");
    return data;
  },
};